module.exports = __webpack_public_path__ + "static/media/logoutbg.d4777195.svg";